import React, { FC, useState } from 'react'
import { Icon } from '@lightspeed/design-system-react'
import { T } from '@transifex/react'

type Props = {
  title: string
  titleContext: string
  content: string
  contentContext: string
  className?: string
  testId?: string
}

export const ExpandableTermsSection: FC<Props> = ({
  title,
  titleContext,
  content,
  contentContext,
  className = 'vd-mb3',
  testId = 'expandable-terms',
}) => {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <div className={className}>
      <div
        style={{ cursor: 'pointer' }}
        onClick={() => setIsExpanded(!isExpanded)}
        data-testid={`${testId}-toggle`}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            color: '#0066cc',
          }}
        >
          <span>
            <T _str={title} _context={titleContext} />
          </span>
          <Icon
            icon={isExpanded ? 'angle-up' : 'angle-down'}
            style={{
              transition: 'transform 0.2s ease',
            }}
          />
        </div>
      </div>
      {isExpanded && (
        <div
          className="vd-text--body vd-text--secondary vd-mb3 vd-mt3"
          data-testid={`${testId}-content`}
        >
          <T _str={content} _context={contentContext} />
        </div>
      )}
    </div>
  )
}
